import React, {useEffect, useState} from "react";
import SafeImage from "../../../layout/reusable/SafeImage";
import SimilarContent from "./SimilarContent";
import {getCMSGeneral} from "../../../utils/cms.utils";

const BlogSingleMain = ({singleData}) => {
    const [general, setGeneral] = useState(null);

    useEffect(() => {
        setGeneral(getCMSGeneral());
    }, []);

    if (!singleData) return null;

    const {
        title,
        caption,
        summaryEn,
        summaryId,
        contents = [],
        images = [],
        tags = [],
        source,
        source_logo,
    } = singleData;

    /* ===== IMAGE INSERT LOGIC ===== */
    const totalParagraph = contents.length;
    const totalImages = images.length;

    const insertEvery =
        totalImages > 0
            ? Math.ceil(totalParagraph / totalImages)
            : 0;

    return (
        <div className="blog-details section-padding">
            <div className="container">
                <div className="col-lg-9 mx-auto">

                    {/* TAGS */}
                    {tags.length > 0 && (
                        <div className="blog-details__tags">
                            {tags.map((tag, idx) => (
                                <span key={idx} className="blog-details__tag">
                                    {tag}
                                </span>
                            ))}
                        </div>
                    )}

                    {/* TITLE */}
                    <h3 className="blog-details__title">{title}</h3>

                    <div className="blog-details__divider"/>

                    {/* HERO IMAGE */}
                    {images[0] && (
                        <SafeImage
                            src={images[0]}
                            alt={title}
                            className="blog-details__hero w-100"
                        />
                    )}

                    {/* LOGOS */}
                    <div className="blog-details__logos">
                        <img src={general?.logo1} alt="RAR Logo"/>

                        {source_logo && (
                            <>
                                <span className="multiply">×</span>
                                <img
                                    src={source_logo}
                                    alt="Source Logo"
                                    className="client-logo"
                                />
                            </>
                        )}
                    </div>
                    <p className="blog-caption text-center">
                        {caption}
                    </p>

                    {/* SUMMARY */}
                    {(summaryEn || summaryId) && (
                        <div className="blog-details__summary">
                            <span className="summary-label">
                                <i className="fa-regular fa-file-lines"/>
                                Summary
                            </span>

                            <div className="summary-grid">
                                {summaryEn && (
                                    <div
                                        className="summary-en"
                                        dangerouslySetInnerHTML={{
                                            __html: summaryEn,
                                        }}
                                    />
                                )}

                                {summaryId && (
                                    <div
                                        className="summary-id"
                                        dangerouslySetInnerHTML={{
                                            __html: summaryId,
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    )}

                    {/* CONTENT TITLE */}
                    <p className="content-label">
                        <span>
                            <i className="fa-regular fa-newspaper"/>
                            Content
                        </span>
                    </p>

                    <div className="blog-details__divider"/>

                    {/* CONTENT + IMAGE INSERT */}
                    {contents.map((item, index) => {
                        const imageIndex =
                            insertEvery > 0
                                ? Math.floor((index + 1) / insertEvery) - 1
                                : -1;

                        const shouldInsertImage =
                            insertEvery > 0 &&
                            (index + 1) % insertEvery === 0 &&
                            images[imageIndex];

                        return (
                            <React.Fragment key={index}>
                                {/* EN */}
                                {item.contentEn && (
                                    <div
                                        className={`blog-details__paragraph ${
                                            index === 0 ? "first" : ""
                                        }`}
                                        dangerouslySetInnerHTML={{
                                            __html: item.contentEn,
                                        }}
                                    />
                                )}

                                {/* ID */}
                                {item.contentId && (
                                    <div
                                        className="blog-details__paragraph blog-details__paragraph--id"
                                        dangerouslySetInnerHTML={{
                                            __html: item.contentId,
                                        }}
                                    />
                                )}

                                {/* IMAGE INSERT */}
                                {shouldInsertImage && (
                                    <SafeImage
                                        src={images[imageIndex]}
                                        alt={title}
                                        className="blog-details__inline-image"
                                    />
                                )}
                            </React.Fragment>
                        );
                    })}

                    {/* SOURCE */}
                    {source && (
                        <div className="blog-details__source">
                            <span>
                                <i className="fa-regular fa-globe"/>
                                Source
                            </span>
                            <p>{source}</p>
                        </div>
                    )}

                    <div className="blog-details__divider dark"/>

                    {/* SIMILAR */}
                    <SimilarContent
                        tags={tags}
                        currentId={singleData.id}
                    />
                </div>
            </div>
        </div>
    );
};

export default BlogSingleMain;
